import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

import CurrencyCell from "../../../component/CurrencyCell";

const columns = [
  { field: "allocation", label: "Allocation" },


  { field: "DirectLabour", label: "Direct Labour" },
  { field: "DirectStore", label: "Direct Store" },
  { field: "OnCostLabour", label: "On Cost Labour" },
  { field: "OnCostStore", label: "On Cost Store" },
  { field: "AllTotal", label: "Total" },
  { field: "TotalLabour", label: "Total Labour" },
  { field: "TotalStore", label: "Total Store" },
  { field: "Proforma", label: "Proforma" },
  { field: "Freight", label: "Freight" },
  { field: "Total", label: "Total" },
];


const parseAmount = (value) => {
  if (value == null) return 0;

  let str = String(value).replace(/,/g, "").trim();

  // Handle trailing minus
  if (str.endsWith("-")) {
    str = "-" + str.slice(0, -1);
  }

  return Number(str) || 0;
};


export default function WGRTable({
  rows,
  shop,
  totals,
  showTotal = true,
}) {
  return (
    <TableContainer>
      <Table
        size="small"
       stickyHeader
      >
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell
                key={column.field}
                align="right"
                sx={{
                  fontWeight: 700,
                  bgcolor: "grey.200",
                }}
              >
                {column.label}
              </TableCell>
            ))}
          </TableRow>




        </TableHead>

        <TableBody>
          {rows.map((row, index) => {






            const totalLabour =
              Number(row["DIRECT LABOUR"] || 0) +
              Number(row["ON COST LABOUR"] || 0);

            const totalStore =
              Number(row["ON COST STORE"] || 0) +
              Number(row["DIRECT STORE"] || 0);

            const freight =
              totalStore * (Number(row["StoreFreight"] || 0) / 100);

            const proforma =
              totalLabour * (Number(row["proformaoncost"] || 0) / 100);



            let total = totalLabour + totalStore + freight + proforma;

            let total1 = totalLabour + totalStore;


            return (
              <TableRow
                key={index}
                hover
                sx={{
                  "&:nth-of-type(even)": {
                    bgcolor: "grey.50",
                  },
                }}
              >



                <TableCell align="right">
                  {row["WORKORDER"]}
                </TableCell>

                <TableCell align="right">
                  <CurrencyCell value={Number(row["DIRECT LABOUR"] || 0)} />
                </TableCell>

                <TableCell align="right">
                  <CurrencyCell value={Number(row["DIRECT STORE"] || 0)} />
                </TableCell>


                <TableCell align="right">
                  <CurrencyCell value={Number(row["ON COST LABOUR"] || 0)} />
                </TableCell>

                <TableCell align="right">
                  <CurrencyCell value={Number(row["ON COST STORE"] || 0)} />
                </TableCell>

                <TableCell align="right">
                  <CurrencyCell value={total1} />
                </TableCell>


                <TableCell align="right">
                  <CurrencyCell value={totalLabour} />
                </TableCell>


                <TableCell align="right">
                  <CurrencyCell value={totalStore} />
                </TableCell>

                <TableCell align="right">
                  <CurrencyCell value={proforma} />
                </TableCell>


                <TableCell align="right">
                  <CurrencyCell value={freight} />
                </TableCell>




                <TableCell align="right">
                  <CurrencyCell value={total} />
                </TableCell>




              </TableRow>



            );
          })}





          {showTotal && (
            <TableRow
              sx={{
                bgcolor: "primary.light",
                "& td": {
                  fontWeight: 700,
                  borderTop: "2px solid",
                  borderColor: "primary.main",
                },
              }}
            >

              <TableCell colSpan={6} align="right">
                Allocation 21.2130.00
              </TableCell>


              <TableCell align="right">
                <CurrencyCell value={totals.TotalLabour} />
              </TableCell>


              <TableCell align="right">
                <CurrencyCell value={totals.TotalStore} />
              </TableCell>




              <TableCell align="right">
                <CurrencyCell value={totals.Proforma} />
              </TableCell>

              
              <TableCell align="right">
                <CurrencyCell value={totals.Freight} />
              </TableCell>

              <TableCell align="right">
                <CurrencyCell value={totals.GrandTotal} />
              </TableCell>



            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}